module.exports = __webpack_public_path__ + "img/img15.10b335e0.png";